import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const dropdownList = {
	ProvozovnaId: [],
	DphSzbOzn: [],
	ZakazkakorekcePzn: [],
};

const edit = {
	DphSzbOzn: null as number | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	KodKorekce: null as string | null,
	Oc: null as number | null,
	Poznamka: null as string | null,
	Poznamka2Dd: null as string | null,
	ProvozovnaId: null as number | null,
	SnId: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	Text: null as string | null,
	UniqIdentifier: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupProvId: null as number | null,
	ZakazkaId: null as number | null,
	ZakazkakorekcePzn: null as number | null,
	ZakazkakorekceTemplId: null as number | null,
	ZaznamId: null as number | null,
	HasSlevaZRuky: null as boolean | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames: [],
	depTableSettings: {},
	localState: {
		UniqCheckPrp: false,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.KOREKCE_KOD_SELECT_MAPPER](state, { data }) {
			state.edit.KodKorekce = data.kodKorekce;
			state.edit.ZakazkakorekceTemplId = data.value;
			if (!data.isClear) {
				state.edit.Oc = data.oc;
				state.edit.ZakazkakorekcePzn = data.zakazkakorekcePzn;
				state.edit.Text = data.text;
				state.edit.ZakazkakorekceTemplId = data.value;
				state.edit.Poznamka = data.poznamka;
			}
			state.localState.UniqCheckPrp = data.uniqCheckPrp;
		},
		[editMutations.KOREKCE_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	props: {
		mode: null,
	},
});
